import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { TestdriveService } from 'src/app/shared/testdrive/testdrive.service';

import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

@Injectable()
export class IsTestdriveAvailableResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsTestdriveAvailable;

  public constructor(private readonly testdriveService: TestdriveService) {}

  public resolve$(): Observable<boolean> {
    return this.testdriveService.getDeeplinkInfo().pipe(
      map(() => true), // valid if there is a result
      catchError((): Observable<boolean> => of(false))
    );
  }
}
